import { configureStore } from '@reduxjs/toolkit';
import authReducer from './slices/authSlice';
import uploadReducer from './slices/uploadSlice';
import userReducer from './slices/userSlice';
import datasetReducer from './slices/datasetSlice';
import uploadProgressReducer from './slices/uploadProgressSlice';
import notificationReducer from './slices/notificationSlice';
import datasetContentReducer from './slices/datasetContentSlice';
import uploadInactivityMiddleware from './middleware/uploadInactivityMiddleware'
import selectedDataProviderReducer from './slices/selectedDataProviderSlice';
import fileExtensionsReducer from './slices/fileExtensionsSlice';
import s3SourcesReducer from './slices/s3SourcesSlice';
import s3JobsReducer from './slices/s3JobsSlice';
import { registerStore } from './storeRef';
/**
 * uploadInactivityListener is used in the store to globally manage inactivity timer behavior based on upload state.
 * .prepend() ensures it runs first for timely and reliable inactivity management.
 */
const store = configureStore({
    reducer: {
        auth: authReducer,
        upload: uploadReducer,
        user: userReducer,
        dataset: datasetReducer,
        uploadProgress: uploadProgressReducer,
        notifications: notificationReducer,
        datasetContent: datasetContentReducer,
        selectedDataProvider: selectedDataProviderReducer, 
        fileExtensions: fileExtensionsReducer,
        s3Sources: s3SourcesReducer,
        s3Jobs: s3JobsReducer,
    },
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: {
                ignoredActions: ['upload/uploadChunk/pending', 'upload/uploadChunk/fulfilled', 'persist/PERSIST'],
                ignoredActionPaths: ['payload.chunk', 'meta.arg.chunk'],
                ignoredPaths: ['upload.currentUpload.chunk'],
            },
        }).prepend(uploadInactivityMiddleware.middleware),
});

registerStore(store);

export default store;


